:host {
   display: block;
}

.expandable-text-wrapper {
   margin-bottom: 0.5rem;
}

.expandable-text-content {
   display: -webkit-box;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;
}

.expandable-text-content.collapsed {
   -webkit-line-clamp: var(--line-clamp, 2);
}

.expandable-text-content.expanded {
   -webkit-line-clamp: unset;
   max-height: none;
}

.toggle-button {
   background: none;
   border: none;
   color: var(--tti-expandable-text-toggle-color);
   cursor: pointer;
   text-decoration: underline;
   padding: 0;
   font-size: 0.75rem;
   margin-top: 0.25rem;
}

.toggle-button:hover {
   color: var(--tti-expandable-text-toggle-hover-color);
}

.toggle-button:focus-visible {
   outline: 2px solid var(--bs-primary, #0d6efd);
   outline-offset: 2px;
   border-radius: 2px;
}

.toggle-button.hidden {
   display: none;
}
